var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.showNewHome)?[_c('main',{staticClass:"guide-home"},[_c(_setup.GuideModuleLoader,{on:{"articleClicked":_setup.handleArticleClick,"authorClicked":_setup.handleAuthorClick}}),_c(_setup.ArticleTimeline)],1),_c(_setup.AppFooter)]:_c(_setup.GuidePage)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }